import { URLS } from '@constants'
import {
  ApiRestrictionData,
  DELETEViewRestrictionParams,
  GETViewRestrictionsParams,
  POSTRestriction,
} from '@types'

import { commonAPI } from './common.api'

export const restrictionsAPI = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchRestrictionsByViewId: build.query<ApiRestrictionData, GETViewRestrictionsParams>({
      query: ({ viewId, restrictionType }) => ({
        url: URLS.FRONT_CFG + `/restriction/getByViewId/${viewId}`,
        params: {
          restrictionType,
        },
      }),
      providesTags: (_, _error, arg) => {
        return [{ type: 'Restrictions', id: arg.viewId }]
      },
    }),
    fetchRestrictions: build.mutation<ApiRestrictionData, GETViewRestrictionsParams>({
      query: ({ viewId, restrictionType }) => ({
        url: URLS.FRONT_CFG + `/restriction/getByViewId/${viewId}`,
        params: {
          restrictionType,
        },
      }),
    }),
    fetchDefaultRestrictionsByView: build.query<ApiRestrictionData, GETViewRestrictionsParams>({
      query: ({ viewId }) => ({
        url: URLS.FRONT_CFG + `/restriction/default/getByViewId/${viewId}`,
        method: 'GET',
      }),
      providesTags: (_, _error, arg) => [{ type: 'DefaultRestrictions', id: arg.viewId }],
    }),
    updateRestrictions: build.mutation<POSTRestriction[], POSTRestriction[]>({
      query: restrictions => ({
        url: URLS.FRONT_CFG + '/restriction',
        method: 'POST',
        body: restrictions,
      }),
      invalidatesTags: (_, _err, arg) => [{ type: 'Restrictions', id: arg?.[0]?.viewId }],
    }),
    updateDefaultRestrictions: build.mutation<POSTRestriction[], POSTRestriction[]>({
      query: restrictions => ({
        url: URLS.FRONT_CFG + '/restriction/default',
        method: 'POST',
        body: restrictions,
      }),
      invalidatesTags: (_, _err, arg) => [{ type: 'DefaultRestrictions', id: arg?.[0]?.viewId }],
    }),
    deleteViewRestrictionsByType: build.mutation<null, DELETEViewRestrictionParams>({
      query: ({ viewId, restrictionType }) => ({
        url: URLS.FRONT_CFG + `/restriction/viewId/${viewId}`,
        method: 'DELETE',
        params: {
          type: restrictionType,
        },
      }),
      invalidatesTags: (_, _err, arg) => [{ type: 'Restrictions', id: arg.viewId }],
    }),
    deleteViewDefaultRestrictionsByType: build.mutation<null, DELETEViewRestrictionParams>({
      query: ({ viewId, restrictionType }) => ({
        url: URLS.FRONT_CFG + `/restriction/default/viewId/${viewId}`,
        method: 'DELETE',
        params: {
          type: restrictionType,
        },
      }),
      invalidatesTags: (_, _err, arg) => [
        { type: 'Restrictions', id: arg.viewId },
        { type: 'DefaultRestrictions', id: arg.viewId },
        'SingleView',
      ],
    }),
  }),
})

export const {
  useFetchRestrictionsByViewIdQuery,
  useLazyFetchDefaultRestrictionsByViewQuery,
  useUpdateDefaultRestrictionsMutation,
  useUpdateRestrictionsMutation,
  useDeleteViewRestrictionsByTypeMutation,
  useDeleteViewDefaultRestrictionsByTypeMutation,
  useLazyFetchRestrictionsByViewIdQuery,
  useFetchRestrictionsMutation,
} = restrictionsAPI
